<template>

    <div class='columns'>

        <div class='column is-2'></div>

        <div class='column is-4'>
            <div class="card" style='margin:auto;max-width:420px;'>
              <div class="card-content">
                <form>
                    <center>
                        <h3 class='subtitle is-5'>Contribute to</h3>
                        <h2 class='title is-4'>{{project.name}}</h2>
                        <hr/>
                        <!-- <img class='image' src='@/assets/logo_tiny.png' /> -->
                    </center>
                    <div class="content">
                        <b-message v-if="error" type="is-danger" has-icon>
                            {{error}}
                        </b-message>

                        <b-field label="Full name">
                            <b-input v-model="name" placeholder="(Optional)"></b-input>
                        </b-field>

                        <b-field label="Amount" :type="{ 'is-danger': !isAmountValid }" :message="isAmountValid ? '' : 'Please enter a valid amount to donate between $5 - $5,000'"><!--</b-field>-->
                        <!-- <b-field> -->
                            <!-- <p class="control">
                                <b-radio-button v-model="amount"
                                    native-value="5.00"
                                    type="is-success">
                                    <span>$5</span>
                                </b-radio-button>
                            </p>
                            <p class="control">
                                <b-radio-button v-model="amount"
                                    native-value="10.00"
                                    type="is-success">
                                    <span>$10</span>
                                </b-radio-button>
                            </p>
                            <p class="control">
                                <b-radio-button v-model="amount"
                                    native-value="25.00"
                                    type="is-success">
                                    <span>$25</span>
                                </b-radio-button>
                            </p> -->
                            <p class="control">
                                <b-input v-model="amount" icon="cash" placeholder="100.00"></b-input>
                            </p>
                        </b-field>

                        <b-field label="Message">
                            <b-input v-model="message" placeholder="Message of support or encouragement" type="textarea" maxlength="120"></b-input>
                        </b-field>

                        <p class='has-text-weight-light'>
                            Clicking <em>Proceed</em> will transfer you to a
                            <span class='has-text-weight-normal'>
                                <b-icon icon="lock" size="is-small"></b-icon>
                                secure Stripe checkout page
                            </span>
                            to finalize your transaction
                        </p>
                        <b-button class='button is-primary is-fullwidth' rounded icon-left="cart-outline"
                            :disabled="!isAmountValid"
                            :loading="isLoading"
                            @click="checkout">Proceed to checkout</b-button>

                        <hr/>

                        <div class='is-size-7 has-text-centered'>
                            <a href='https://stripe.com/docs/security/stripe' target='_blank'><b-icon icon="lock" size="is-small"></b-icon><span>Stripe security</span></a>
                        </div>
                    </div>
                </form>
              </div>
            </div>
        </div>

        <div class='column is-4'>
            <br/>

            <div class='columns'>
                <div class='column is-3'>
                    <figure class="image is-4x3">
                      <img :src="project.image[0].sizes.card">
                    </figure>
                </div>
                <div class='column'>
                    <h4 class='title is-4'>{{project.name}}</h4>
                    <h6 class='subtitle is-6'>{{project.pitch}}</h6>
                    <p>{{project.description}}</p>

                    <br/>

                    <h4 class='title is-5'>Team</h4>
                    <div id='team'>
                        <article class="media" v-for="role in roles" :key="role.id" v-if="role.user">
                          <figure class="media-left">
                              <figure class="image is-48x48">
                                <img class='is-rounded' :src="role.user.image[0].sizes.circularList">
                              </figure>
                          </figure>
                          <div class="media-content">
                              <h5 class="title is-5 has-text-weight-normal">{{role.user.firstName}} {{role.user.lastName}}</h5>
                              <h5 class="subtitle is-6">{{role.name}}</h5>
                          </div>
                        </article>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<style scoped>
#team .title { font-size: 1.1em; }
.heading { font-size: 0.85em; }
</style>

<script>
export default {
  name: 'Donate',
  data () {
    return {
        name: '',
        amount: "10.00",
        message: '',

        project: {},
        roles: [],

        isLoading: false, // when Checkout is clicked, and the checkout logic is pending
        error: '', // contains text related to a transaction error
        // availableAmounts: [5, 10, 25]
    }
  },
  computed: {
    isAmountValid: function() {
        // Form is valid based on the donation amount value, if:
        //  (1) is not empty
        //  (2) does not contain non-numeric characters
        //  (3) does not contain multiple dots
        //  (4) does not contain more than two decimal places
        //  (5) is parseable as a float
        //  (6) is greater than or equal to $5
        //  (7) is less than or equal to $5,000
        if(this.amount.length === 0) return false;
        if(this.amount.match(/[a-z]/i)) return false;
        if(this.amount.indexOf('.') !== this.amount.lastIndexOf('.')) return false; // multiple dots
        if(this.amount.indexOf('.') !== -1) {
            if(this.amount.substring(this.amount.indexOf('.') + 1).length > 2) return false; // no more than two decimal places
        }

        try {
            var val = Number.parseFloat(this.amount);
            if(val < 5) return false;
            if(val > 5000) return false;
        }
        catch(e) { return false; }

        return true;
    }
  },
  mounted() {
    // Load Stripe.js dependency
    // See: https://medium.com/@lassiuosukainen/how-to-include-a-script-tag-on-a-vue-component-fe10940af9e8
    var stripejs = document.createElement('script');
    stripejs.setAttribute('src', 'https://js.stripe.com/v3/');
    document.head.appendChild(stripejs);

    if(this.$root.isLoggedIn) {
        this.name = this.$root.user.firstName + ' ' + this.$root.user.lastName;
    }

    this.$http.get(this.$hostname + '/project/' + this.$route.params.projectId).then(function(response) {
        this.project = response.body;
    });

    this.$http.get(this.$hostname + '/project/' + this.$route.params.projectId + '/roles').then(function(response) {
        this.roles = response.body;
        console.log('roles', this.roles);
    });
  },
  methods: {
    checkout: function() {
        // Reset error message and set to loading
        this.error = '';
        this.isLoading = true;

        var projectId = this.$route.params.projectId,
            // Ensure that the `amount` being sent is a whole-value; any fractional part of a cent is removed.
            // Floating point arithmetic could cause non-integer values, e.g. $10.05 --> 10.05 * 100 = 1005.0000000000001 cents
            amountToCents = (this.amount * 100).toString(),
            decimalInAmount = amountToCents.indexOf('.'),
            amountToCentsSanitized = amountToCents.substring(0, decimalInAmount === -1 ? amountToCents.length : decimalInAmount);

        // Obtain a checkout session for this transaction
        this.$http.post(this.$hostname + '/checkout/' + projectId, {
            name: this.name,
            message: this.message,
            amount: parseInt(amountToCentsSanitized)
        }).then(function(response) {
            if(response.status === 200) {
                var stripe = Stripe('pk_test_xafzU2XSR8Py8R2ZYm0jliE5'); // TODO: change this in production - load from environment
                stripe.redirectToCheckout({
                  // Make the id field from the Checkout Session creation API response
                  // available to this file, so you can provide it as parameter here
                  // instead of the {{CHECKOUT_SESSION_ID}} placeholder.
                  sessionId: response.body.session.id
                }).then(function (result) {
                  // If `redirectToCheckout` fails due to a browser or network
                  // error, display the localized error message to your customer
                  // using `result.error.message`.
                  this.error = result.error.message;
                });
            }
        }, function(error) {
            this.error = 'Something went wrong with this transaction. Please try again';
        }).finally(function() {
            this.isLoading = false;
        });

        // var projectId = this.$route.params.projectId;
        // var data = {
        //     name: this.name,
        //     amount: this.amount,
        //     message: this.message
        // };
        // this.$http.post(this.$hostname + '/donate/' + projectId, data).then(function(response) {
        //     if(response.status === 200) {
        //         // Redirect back to project page
        //         this.$router.push({ path: '/project/' + projectId });
        //     }
        // }, function(error) {
        //     console.log(error);
        // });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/Donate.vue